/* SCENT & SILK 2.0 — progressive enhancement. Shopify remains the source of
   truth for product prices, inventory, orders and checkout. No tracking. */
(() => {
  'use strict';
  const standalone = document.documentElement.hasAttribute('data-ss-standalone');
  const remembered = new Map();
  let chosen = null;
  let returnFocus = null;
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const showDialog = (id) => {
    const dialog = document.getElementById(id);
    if (!(dialog instanceof HTMLDialogElement)) return;
    document.querySelectorAll('dialog[open]').forEach(d => d.close());
    returnFocus = document.activeElement;
    dialog.showModal();
    document.body.classList.add('ss-dialog-open');
  };
  const closeDialog = (dialog) => {
    if (dialog instanceof HTMLDialogElement) dialog.close();
  };
  const concept = (card) => {
    if (!(card instanceof HTMLElement)) return;
    const image = card.querySelector('.ss-product-photo');
    chosen = {name: card.dataset.ssName || 'Dein Duft', handle: card.dataset.ssHandle || '', src: image?.currentSrc || image?.src || ''};
    const title = document.getElementById('ssScentTitle');
    const photo = document.getElementById('ssScentImage');
    if (title) title.textContent = chosen.name;
    if (photo && chosen.src) { photo.src = chosen.src; photo.alt = `Bildkonzept für ${chosen.name}; kein finales Produktfoto`; }
    const button = document.getElementById('ssDemoRemember');
    if (button) { button.hidden = !standalone; button.textContent = remembered.has(chosen.handle) ? 'Bereits in deiner Vorschau gemerkt' : 'In der Vorschau merken'; }
    showDialog('ssScentDialog');
  };
  const info = (key) => {
    const content = {
      bundles: ['Deine Düfte. Als Set.', 'Duftsets sind als mögliche Erweiterung geplant. Zusammensetzung, Preise und Verfügbarkeit stehen noch nicht fest. In dieser Vorschau kannst du noch kein Bundle kaufen.'],
      abo: ['Dein Duft. Immer wieder.', 'Ein Duft-Abonnement ist für später angedacht. Lieferintervalle, Preise und Bedingungen sind noch offen. Dieser Entwurf richtet kein Abo ein und löst keine Zahlung aus.'],
      newsletter: ['Bleib in unserer Duftwelt.', 'Die Newsletter-Anmeldung ist noch nicht freigeschaltet. Hier werden keine E-Mail-Adressen erfasst oder Werbe-E-Mails versendet.'],
      legal: ['Vor dem Verkaufsstart.', 'Firmenangaben sowie die passenden Datenschutz-, Versand- und weiteren Geschäftsbedingungen werden vor dem Verkaufsstart ergänzt. Diese Designvorschau enthält keine erfundenen rechtlichen Angaben.']
    };
    const [title, text] = content[key] || content.legal;
    document.getElementById('ssInfoTitle').textContent = title;
    document.getElementById('ssInfoText').textContent = text;
    showDialog('ssInfoDialog');
  };
  const updateRail = (rail) => {
    if (!(rail instanceof HTMLElement)) return;
    const id = rail.id;
    document.querySelectorAll('[data-ss-slide]').forEach(button => {
      if (button.getAttribute('aria-controls') !== id) return;
      const end = rail.scrollWidth - rail.clientWidth;
      button.disabled = Number(button.dataset.ssSlide) < 0 ? rail.scrollLeft <= 3 : rail.scrollLeft >= end - 3;
    });
  };
  const findCard = (handle) => [...document.querySelectorAll('.ss-product-card')].find(c => c.dataset.ssHandle === handle);
  const renderSearch = () => {
    const input = document.getElementById('ssSearchInput');
    const target = document.getElementById('ssSearchResults');
    if (!input || !target) return;
    const normalize = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const needle = normalize(input.value.trim());
    target.replaceChildren();
    let count = 0;
    document.querySelectorAll('.ss-product-card[data-ss-handle]').forEach(card => {
      const name = card.dataset.ssName || '';
      if (!normalize(name).includes(needle)) return;
      count++;
      const row = document.createElement('div'); row.className = 'ss-search-result';
      const originalImage = card.querySelector('img');
      if (originalImage) { const img = document.createElement('img'); img.src = originalImage.currentSrc || originalImage.src; img.alt = ''; img.width = 65; img.height = 65; row.append(img); }
      const button = document.createElement('button'); button.type = 'button'; button.textContent = name;
      button.addEventListener('click', () => concept(card));
      const status = document.createElement('small'); status.textContent = 'Wäscheparfüm · Bildkonzept'; button.append(status); row.append(button); target.append(row);
    });
    if (!count) { const text = document.createElement('p'); text.textContent = 'Kein Duft mit diesem Namen gefunden.'; target.append(text); }
  };
  const renderRemembered = () => {
    const list = document.getElementById('ssRememberedList');
    if (!list) return;
    list.replaceChildren();
    remembered.forEach((value,key) => {
      const li = document.createElement('li'); const text = document.createElement('span'); text.textContent = value.name;
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Entfernen'; remove.setAttribute('aria-label', value.name + ' aus der Vorschau entfernen');
      remove.addEventListener('click', () => { remembered.delete(key); renderRemembered(); }); li.append(text,remove); list.append(li);
    });
    const empty = document.getElementById('ssRememberedEmpty');
    if (empty) empty.hidden = remembered.size > 0;
    document.querySelectorAll('.ss-cart-count').forEach(el => { el.textContent = String(remembered.size); });
    document.querySelectorAll('.ss-cart-link').forEach(el => el.setAttribute('aria-label', `Vorschau-Auswahl, ${remembered.size} Düfte`));
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const target = event.target;
    const close = target.closest('[data-ss-close]');
    if (close) { closeDialog(close.closest('dialog')); return; }
    const cardButton = target.closest('[data-ss-concept]');
    if (cardButton) { concept(cardButton.closest('.ss-product-card')); return; }
    const infoButton = target.closest('[data-ss-info]');
    if (infoButton) { info(infoButton.dataset.ssInfo); return; }
    const slide = target.closest('[data-ss-slide]');
    if (slide) {
      const rail = document.getElementById(slide.getAttribute('aria-controls'));
      if (rail) rail.scrollBy({left: Number(slide.dataset.ssSlide) * rail.clientWidth, behavior: reducedMotion() ? 'instant' : 'smooth'});
      return;
    }
    if (target.closest('#ssDemoRemember') && standalone && chosen) {
      remembered.set(chosen.handle, {...chosen}); renderRemembered(); showDialog('ssCartDemo'); return;
    }
    const link = target.closest('a');
    if (link) {
      const mobile = link.closest('.ss-mobile-menu'); if (mobile) mobile.open = false;
      const href = link.getAttribute('href') || '';
      if (href.startsWith('#duft-')) {
        const card = findCard(href.replace('#duft-',''));
        if (card) { event.preventDefault(); const rail = card.closest('[data-ss-rail]'); const child = card.closest('.ss-rail-item'); if (rail && child) rail.scrollTo({left: child.offsetLeft - rail.offsetLeft, behavior: reducedMotion() ? 'instant':'smooth'}); document.getElementById('kollektion')?.scrollIntoView({behavior: reducedMotion() ? 'instant':'smooth'}); }
      }
      if (standalone) {
        if (href === '/search') { event.preventDefault(); showDialog('ssSearchDemo'); renderSearch(); document.getElementById('ssSearchInput')?.focus(); }
        if (href === '/cart') { event.preventDefault(); renderRemembered(); showDialog('ssCartDemo'); }
        if (href === '/collections/all') { event.preventDefault(); showDialog('ssSearchDemo'); document.getElementById('ssSearchInput').value = ''; renderSearch(); }
        if (href === '/') { event.preventDefault(); window.scrollTo({top:0,behavior:reducedMotion()?'instant':'smooth'}); }
        if (href.startsWith('/#')) { event.preventDefault(); document.getElementById(href.slice(2))?.scrollIntoView({behavior:reducedMotion()?'instant':'smooth'}); }
      }
    }
    document.querySelectorAll('.ss-desktop-subnav[open]').forEach(menu => { if (!menu.contains(target)) menu.open = false; });
  });
  document.addEventListener('change', event => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-ss-variant]')) return;
    const url = new URL(window.location.href); url.searchParams.set('variant', select.value); window.location.assign(url.toString());
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const activeDialog = document.querySelector('dialog[open]');
    if (activeDialog instanceof HTMLDialogElement) { event.preventDefault(); activeDialog.close(); return; }
    document.querySelectorAll('.ss-mobile-menu[open], .ss-desktop-subnav[open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); });
  });
  document.addEventListener('input', event => { if (event.target.id === 'ssSearchInput') renderSearch(); });
  const init = () => {
    document.querySelectorAll('dialog').forEach(dialog => {
      if (dialog.dataset.ssReady) return; dialog.dataset.ssReady = 'true';
      dialog.addEventListener('close', () => { if (!document.querySelector('dialog[open]')) document.body.classList.remove('ss-dialog-open'); if (returnFocus instanceof HTMLElement && returnFocus.isConnected) returnFocus.focus({preventScroll:true}); });
      dialog.addEventListener('click', event => { if (event.target !== dialog) return; const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); });
    });
    document.querySelectorAll('[data-ss-rail]').forEach(rail => { if (!rail.dataset.ssReady) { rail.dataset.ssReady = 'true'; rail.addEventListener('scroll', () => updateRail(rail), {passive:true}); } updateRail(rail); });
  };
  init();
  window.addEventListener('load', init, {once:true});
  window.addEventListener('resize', () => document.querySelectorAll('[data-ss-rail]').forEach(updateRail), {passive:true});
  document.addEventListener('shopify:section:load', init);
})();
